<template>
  <!-- 登陆页 -->
  <div class="login_page">
    <!-- 背景 -->
    <div class="login_bg"></div>
    <!-- 登陆表单 -->
    <div class="form_box">
      <h1>搜索指数后台管理系统</h1>
      <!-- <img src="@/assets/img/loginLogo.png" alt=""> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="userName">
          <el-input
            type="text"
            v-model="ruleForm.userName"
            clearable
            placeholder="请输入账号"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            clearable
            placeholder="请输入密码"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="handleLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        userName: '',
        password: '',
      },
      rules: {
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
    }
  },
  methods: {
    // 点击登陆
    handleLogin() {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          return
        }
        this.$http({
          url: '/:32710/login/user',
          data: this.ruleForm,
          method: 'POST',
        })
          .then((res) => {
            if (200 !== Number(res.code)) {
              throw res
              return
            }
            this.$notify.success('登录成功')
            setTimeout(() => {
              this.$router.replace('/index')
            }, 600)
          })
          .catch((error) => {
            this.$notify.error(error.message ? error.message : '登录失败')
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.login_page {
  width: 100vw;
  height: 100vh;
  .login_bg {
    width: 100%;
    height: 100%;
    background: url('../../assets/img/login_bg.jpg');
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  .form_box {
    position: fixed;
    top: 35%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    > h1 {
      color: #eee;
      font-size: 35px;
      margin-bottom: 30px;
      text-align: center;
    }
    > img {
      width: 190px;
      margin-bottom: 30px;
    }
    >>> .el-form {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-left: 10px;
      }
      .el-form-item__error {
        color: #f56c6c;
      }
      .el-input__inner {
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
      }
      .el-input.is-active .el-input__inner,
      .el-input__inner:focus {
        border-color: #8193b2;
      }
      .el-button--primary {
        height: 38px;
        background: rgba(255, 255, 255, 0.3);
        border: 1px solid #c6c6c6;
        color: #eee;
      }
      .el-button--primary.is-plain:hover,
      .el-button--primary.is-plain:active,
      .el-button--primary.is-plain:focus {
        color: #8193b2;
        border: 1px solid #8193b2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue